import React from 'react';
import { useTranslations } from '../../../../hooks/useTranslations';
import { Field } from 'formik';
import FieldInput from '../../../../../../../../../../../../components/FieldInput';
import {
  OpenValidConversationQuestion,
  QuestionValidConversationTemplateItem,
  ValidConversationTemplate,
} from '../../../../../../../../../../../../interfaces/conversations';
import { useTypedContext } from '../../../../../../../../../../../../hooks/useTypedContext';
import { LanguageContext } from '../../../../types';
import { AVAILABLE_CULTURES } from '../../../../../../../../../../../../components/CultureSelector/CultureSelector';
import { useGeneratePlaceholder } from '../../../../hooks/useGeneratePlaceholder';

type OpenProps = {
  index: number;
  values: ValidConversationTemplate;
};

const Open = ({ index, values }: OpenProps) => {
  const { providerInvariant } = useTranslations();

  const language = useTypedContext(LanguageContext);
  const isDefaultCulture = language.culture === AVAILABLE_CULTURES.EN;

  const getPlaceholder = useGeneratePlaceholder(isDefaultCulture);

  const questionItem = values.content[
    index
  ] as QuestionValidConversationTemplateItem;

  const openQuestion = questionItem.value as OpenValidConversationQuestion;

  return (
    <>
      <Field
        required={false}
        placeholder={getPlaceholder(
          'answerMaxLength',
          openQuestion.answer_max_length
        )}
        label={providerInvariant.wrapWithIntl(
          providerInvariant.attachPrefix('answerMaxLength')
        )}
        id={`content[${index}].value.answer_max_length`}
        name={`content[${index}].value.answer_max_length`}
        type="number"
        component={FieldInput}
      />
      <Field
        required={false}
        placeholder={getPlaceholder(
          'answerPlaceholder',
          openQuestion.answer_placeholder
        )}
        label={providerInvariant.wrapWithIntl(
          providerInvariant.attachPrefix('answerPlaceholder')
        )}
        id={`content[${index}].value.answer_placeholder`}
        name={`content[${index}].value.answer_placeholder`}
        type="text"
        component={FieldInput}
      />
    </>
  );
};

export default Open;
